import {useQuery} from '@tanstack/react-query';
import {fetchSystemHealth} from './system-health-api';

/**
 * Polls every 10 seconds.
 *
 * A health screen that only updates when you reload is not a health screen — the whole reason to
 * open it is to watch something change. The backend excludes this endpoint from its own request
 * metrics, so the polling does not inflate the numbers it is reporting.
 */
export const useSystemHealth = () =>
    useQuery({
        queryKey: ['system-health'],
        queryFn: fetchSystemHealth,
        refetchInterval: 10_000,
        refetchOnWindowFocus: true,
    });
